<template>
  <section class="section">
    <div class="is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Vagalumes</h1>
          </div>
          <!-- <h3 style="color:#888888" class="subtitle"> {{getClientName()}}</h3> -->
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-button tag="router-link" to="/notifications" type="is-info"
              >Alertas</b-button
            >
          </div>
          <div class="level-item"></div>
        </div>
      </div>
    </div>
    <div class="card has-table">
      <div class="card-header"></div>

      <b-table
        :data="desserts"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
        striped
      >
        <template slot-scope="props">
          <b-table-column field="name" label="Nome" sortable>
            {{
              props.row.name.split("--")[1] == null
                ? props.row.name.split("_")[1]
                : props.row.name.split("--")[1]
            }}
          </b-table-column>

          <b-table-column
            field="is_online"
            label="Status"
            sortable
            v-if="props.row.historico"
          >
            <span
              :class="['tag', props.row.is_online ? 'is-success' : 'is-danger']"
            >
              {{ props.row.historico[0].status }}</span
            >
          </b-table-column>
          <b-table-column field="ip" label="Endereço IP" sortable>
            {{ props.row.ip }}
          </b-table-column>
          <b-table-column
            field="total_connected"
            label="Nº Conectados"
            sortable
          >
            {{
              props.row.historico[0].status == "online"
                ? props.row.total_connected
                : "offline"
            }}
          </b-table-column>
          <b-table-column
            label="Ativo desde"
            field="uptime"
            sortable
            v-if="props.row.historico"
          >
            {{
              props.row.historico[0].status == "online"
                ? new Date(props.row.uptime).toLocaleDateString("pt-BR") +
                  " " +
                  new Date(props.row.uptime).toLocaleTimeString("pt-BR")
                : ""
            }}
            <b-button
              style="text-align: right"
              v-if="props.row.is_online && props.row.mac"
              size="is-small"
              @click.native="zabbix(props.row.mac.toUpperCase())"
              type="is-info"
              >Pisca</b-button
            >
          </b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="has-text-grey has-text-centered">
              <span>Sem Vagalumes para exibir</span>
            </div>
          </section>
        </template>
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import Webservices from "@/Webservices";
import { mapActions, mapGetters } from "vuex";
import store from "@/store";
import axios from "axios";
import sms_credentials from "../../static/sms_credentials.json";

var FileSaver = require("file-saver");
const Json2csvParser = require("json2csv").Parser;

const ws = new Webservices();

export default {
  data: () => ({
    perPage: 25,
    desserts: [],
    dialog: false,
    headers: [
      {
        text: "Nome",
        align: "left",
        value: "text",
        sortable: true
      },
      {
        text: "StatusAP",
        align: "left",
        sortable: true
      },
      {
        text: "Tipo",
        align: "left",
        value: "text",
        sortable: true
      },
      {
        text: "Validade",
        align: "left",
        value: "text"
      },
      {
        text: "Disponibilidade",
        value: "disponibilidade",
        sortable: true,
        align: "true"
      },
      {
        text: "Capacidade",
        value: "numDispositivos",
        sortable: true,
        align: "true"
      },
      {
        text: "Actions",
        align: "left",
        value: "name",
        sortable: false
      }
    ],
    editedIndex: -1,
    editedItem: {
      qtd: 1,
      numDispositivos: 1,
      type: "",
      exhibitionType: 0,
      validade: 24,
      observacoes: "",
      dataCriacao: new Date(),
      cpf: null,
      dispositivos: [],
      format: "####-####"
    },
    defaultItem: {
      qtd: 1,
      numDispositivos: 1,
      type: "",
      exhibitionType: 0,
      validade: 24,
      observacoes: "",
      code: 0,
      dataCriacao: new Date(),
      cpf: null,
      dispositivos: [],
      format: "####-####"
    }
  }),
  computed: {
    ...mapGetters(["getRules", "getClientID", "getRadioPrefix", "getToken"]),
    formTitle() {
      return this.editedIndex == -1 ? "Novo Radios" : "Editar Radios";
    },
    isEdited() {
      return this.editedIndex != -1;
    },
    formOkLabel() {
      return this.editedIndex == -1 ? "Criar" : "Atualizar";
    }
  },

  mounted() {
    ws.setToken(this.getToken);
    ws.getRadiosByRadioPrefix(this.getRadioPrefix)
      .then(res => {
        this.desserts = res.data;
        this.correctRadioModel();

        //console.log(this.desserts)
      })
      .catch(err => {
        console.log(err);
      });
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    getClientID(newValue) {
      this.desserts = [];

      ws.getRadiosByRadioPrefix(newValue).then(res => {
        this.desserts = res.data;
        this.correctRadioModel();
      });
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    zabbix(mac) {
      ws.zabbixHost(mac).then(res => {});
    },
    getClientName() {
      return store.state.client.name;
    },
    // sendSms(radios) {
    //     //procurar nos Vouchers
    // },
    correctRadioModel() {
      var i;

      for (i = 0; i < this.desserts.length; i++) {
        if (!!this.desserts[i].historico[0]) {
          if (this.desserts[i].historico[0].status == "online") {
            this.desserts[i]["uptime"] = this.desserts[i].historico[0].date;
            this.desserts[i]["is_online"] = true;
          } else {
            this.desserts[i]["uptime"] = 0;
            this.desserts[i]["is_online"] = false;
          }
        } else {
          this.desserts[i]["uptime"] = 0;
          this.desserts[i]["is_online"] = false;
        }

        this.desserts[i]["total_connected"] = this.desserts[i].total5ghz
          ? this.desserts[i].total5ghz + this.desserts[i].total2ghz
          : this.desserts[i].total2ghz
          ? this.desserts[i].total2ghz
          : 0;
      }
    }
  }
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize !important;
}
</style>



// WEBPACK FOOTER //
// src/components/RadiosButton.vue